/** @jsx jsx */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { jsx } from '@emotion/core';
import { useMediaQuery, useTheme } from '@material-ui/core';

import {
  userChallenges,
  userChallengeDeclarations,
  setSelectedChallengeDataAction,
} from 'actions/challenge.actions';
import { challengesErrorSelector } from 'reducers/challenge.reducer';
import { StyledContainer } from './styles';
import History from '../../components/pages/History';
import { ICustomTheme } from 'interfaces';
import ErrorRedirectionView from 'components/ErrorRedirectionView';
import { useTranslation } from 'react-i18next';
import { ROUTES } from 'constants/index';

export const HistoryOfDeclaredChallenges = (): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id: urlChallengeId } = useParams<{ id: string }>();

  /*  
      check if the dispatch of userChallenges action
      which obtain a list of user-declared challenges is on success or failed status
      the rendering depends on it
  */
  const error = useSelector(challengesErrorSelector);
  const isCallUserDeclaredChallengesFailed = error && error !== null;

  useEffect(() => {
    dispatch(userChallenges.request());
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      userChallengeDeclarations.request({
        challengeId: urlChallengeId,
      }),
    );
  }, [urlChallengeId, dispatch]);

  useEffect(() => {
    dispatch(
      setSelectedChallengeDataAction.request({
        selectedChallengeId: urlChallengeId,
        isMobile,
      }),
    );
  }, [dispatch, urlChallengeId, isMobile]);

  return (
    <StyledContainer>
      {isCallUserDeclaredChallengesFailed ? (
        <ErrorRedirectionView
          errorText={t(
            'challenges.declaration.history.failed_call_action_list',
          )}
          actionText={t(
            'challenges.declaration.history.action_failed_call_action_list',
          )}
          buttonText={t('menu.home')}
          redirection={ROUTES.HOME}
          isMobile={isMobile}
        />
      ) : (
        <History />
      )}
    </StyledContainer>
  );
};
